import React from 'react'

import "./table.scss";
import {  useEffect, useState } from "react";

export default function Utable() {
  const [orderAll, setOrderAll] = useState([]);

  const fetchData= async()=> {
      const response = await fetch('http://localhost:8000/order/allOrders',
        {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      }
    }
      );
      const data = await response.json();
      // Sort orderData by descending order of latest order date
      // data.orderData.sort((a, b) => {
      //   const aLatestOrderDate = new Date(a.order_data[a.order_data.length - 1][0].Order_date);
      //   const bLatestOrderDate = new Date(b.order_data[b.order_data.length - 1][0].Order_date);
      //   return bLatestOrderDate - aLatestOrderDate;
      // });
      setOrderAll(data.orderData);
    }
  const formatDate = (date) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(date).toLocaleString("en-US", options);
  }
  useEffect(() => {
    fetchData()
  },[])
  return (
    <>
      <table className="table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Id</th>
            <th scope="col">Email</th>
            <th scope="col">Product</th>
            <th scope="col">Date</th>
            <th scope="col">Amount</th>
          </tr>
        </thead>
        <tbody>
          {
            orderAll.map((order, index) => (
              <React.Fragment key={index}>
                <tr>
                  <th rowSpan={order.order_data.length + 1} scope="row">
                    {index + 1}
                  </th>
                  <td rowSpan={order.order_data.length + 1}>{order._id}</td>
                  <td rowSpan={order.order_data.length + 1}>{order.email}</td>
                </tr>
                {order.order_data.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <div className="cellWrapper">
                        <img src={`http://localhost:8000/public/images/${item[1].productImage}`} alt="" className="image" />
                        {item[1].productTitle}
                      </div>
                    </td>
                    <td>{formatDate(item[0].Order_date)}</td>
                    <td>₹{item[1].productAmount}</td>
                    <td></td>
                  </tr>
                ))}
              </React.Fragment>
            ))
          }

        </tbody>
      </table>


      </>
    )     

}

